<template>
  <el-container>
    <nav class="fixed top-0 w-full bg-white backdrop-blur-sm z-50 shadow-sm">
      <div class="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
        <div class="flex items-center space-x-2">
          <img :src="logoUrl" alt="绩溪县适之青少年俱乐部" class="h-12 w-12 object-contain"/>
          <span class="text-2xl font-bold text-blue-600">绩溪县适之青少年俱乐部</span>
        </div>
        <div class="flex space-x-8">
          <a v-for="(item, index) in navItems" :key="index" :href="item.href"
             class="text-gray-600 hover:text-blue-600 transition-colors duration-300 cursor-pointer">
            {{ item.title }}
          </a>
        </div>
      </div>
    </nav>
    <div class="home-main">
      <div class="home-card">
        <div class="home-card-content">
          <div class="title">
            <p class="subtitle">
              绩溪县适之青少年体育俱乐部
            </p>
            <p class="subtitle">
               2025年夏季班招生简章
            </p>
          </div>
          <div>
            <p>
              适之青少年体育俱乐部致力于发展体育运动，立足于增进每个学生健康，给每个学生提供锻炼、提升、展示自己的机会，营造学校、家庭、社会一体的锻炼氛围，激励广大学生在规范有序的体育运动中丰富生活、掌握技能、锻炼体质、磨砺意志、享受快乐，促进学生健康快乐地成长。<br>
            </p>
            <p>
              培训聘任经验丰富、业务精湛的体育专业教师担任教练，每位教练员在历年培养学生参加县市省乃至国家级赛中均多次荣获优异成绩。其中，2024年适之青少年体育俱乐部软式棒垒球培训学员在全国软式棒垒球锦标赛中获第二名；2023年初中组学员软式棒垒球获省一等奖；在2020年安徽省3V3篮球锦标赛中初中组学员女子代表队获省第六名，男子代表队获省第十名；在2021年安徽省3V3篮球锦标赛中初中组学员女子代表队获省第七名；2022年俱乐部小学组学员男女子篮球、乒乓球、科技体育代表队参加宣城市篮球、乒乓球、科技体育赛，女篮获团体冠军、男女乒乓球获团体亚军、科技体育获冠军；中组学员女子篮球代表队获宣城市第三名；俱乐部学员在安徽省田径锦标赛以及传统项目学校比赛中均获得优异成绩。
            </p>
            <p>
              现拟定于2025年秋季开办篮球、足球、体能、激光射击等培训班。按照每个学段分班教学，针对不同学段分别制定训练计划，各班分别委派专业教练进行分班教学。欢迎广大青少年踊跃报名！
            </p>
            <h2>
              一、指导思想
            </h2>
            <p>
                健康第一、引导参与、以体育人
            </p>
            <h2>
              二、招生对象
            </h2>
            <p>
              7周岁及以上身心健康的学生
            </p>
            <p class="content-danger">注意：学员报名时需提供家长的姓名、联系电话、以及学员的身份证号码，以便于为参训学员购买保险。</p>
            <h2>
              三、培训方式
            </h2>
            <p>
                根据学生的实际水平，进行分层次教学，因材施教
            </p>
            <h2>
              四、师资力量
            </h2>
            <p>
              聘请具有丰富经验的专业教师
            </p>
            <h2>
              五、报名时间
            </h2>
            <p>
              2025年6月10日至2025年7月10日下午2:00，各班满员后不再接受报名
            </p>
            <h2>
              六、培训地点
            </h2>
            <p>
              各培训点（实验小学、桂枝小学、扬之小学、适之中学、东山中学、实验小学吴家山校区）
            </p>
            <h2>
              七、培训时间
            </h2>
            <p>
              周六周日上午或下午，一个训练课时100分钟，分段分班教学，本学期共20次课。后期训练时间根据季节变化各培训点酌情调整
            </p>
            <p>
              咨询电话：18098569377（微信同号）
            </p>
            <p>
              报名过程中遇到问题可加微信（微信号 58015）进行处理
            </p>
          </div>
        </div>
      </div>
      <div class="home-card">
        <div class="home-card-content">
          <el-row :gutter="20">
            <el-col class="home-card-col" :span="12" v-for="(item, index) in siteList" :key="index">
              <el-card :body-style="{ margin: '20px' }">
                <img :src="item.photo" class="image" alt="图片加载中...">
                <div style="padding: 14px;">
                  <div>
                    <span class="name">{{item.siteName}}</span>
                    <div class="bottom">
                      <span class="address-class"><i class="el-icon-location-information"></i>{{item.address}}</span>
                      <el-button class="button" type="success" @click="viewDetails(item)" :disabled="num !== 10" round>我要报名</el-button>
                      <!--                    <el-button class="button" type="info" @click="viewDetails(item)" round>详情介绍</el-button>-->
                    </div>
                    <div class="bottom2">
                      <el-tooltip class="item" effect="dark" :content="item.description" placement="bottom-start">
                        <span class="address-class">{{item.description}}</span>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
<!--    <el-footer class="el-footer">
      <div class="footer-div">Copyright © 2025-2026 jxszclub.com All Rights Reserved.</div>
      <div class="footer-div">皖ICP备2025078433号</div>
    </el-footer>-->
    <ProjectDialog ref="projectDialog" @showSignUp="showSignUp"/>
    <SignUpDialog ref="signUpDialog" @showQrCode="showQrCode"/>
    <QrCodeDialog ref="qrCodeDialog"/>
  </el-container>
</template>
<script>
import ProjectDialog from '@/views/Sport/ProjectDialog.vue'
import SignUpDialog from '@/views/Sport/SignUpDialog.vue'
import QrCodeDialog from "@/views/Sport/QrCodeDialog.vue";
import {GetRequest} from "@/request";
  export default {
    components: {ProjectDialog, SignUpDialog,QrCodeDialog},
    data() {
      return {
        logoUrl: 'https://ai-public.mastergo.com/ai/img_res/1c028ef08f60fe9a9e3c627b321b2fc4.jpg',
        heroImage:'https://ai-public.mastergo.com/ai/img_res/3f20d22e35f16b5da96c978bef299623.jpg',
        navItems: [ {title: '返回首页', href: '/'},
          ],
        currentDate: new Date(),
        siteList: [],
        projectList: [],
        baseURL: process.env.NODE_ENV == "development" ? "/pack" : "/prod-api",
        site: null,
        project: null,
        fit: "contain",
        num: null,
      }
    },
    created() {
      this.getSiteList();
      this.getSignUpDate();
    },
    methods: {
      viewDetails(val) {
        this.site = val;
        this.getProjectList(val.siteId);
      },
      getSiteList() {
        let params = {
        }
        GetRequest("/club/site/getSites", {
          ...params
        },{
          headers: {
            isToken: false
          },
        }).then((res) => {
              this.siteList = res.data.map((item) => {
                item.photo = window.location.origin + item.photo;
                return item;
              });
            })
            .finally(() => {

            });
      },
      getProjectList(val) {
        let params = {
          siteId: val
        }
        GetRequest("/club/project/getProjects", {
          ...params
        },{
          headers: {
            isToken: false
          },
        }).then((res) => {
              this.projectList = res.data;
              this.$refs.projectDialog.showDialog(this.projectList)
            })
            .finally(() => {

            });
      },
      getSignUpDate(val) {
        GetRequest("/club/date/signUpDate", {
        },{
          headers: {
            isToken: false
          },
        }).then((res) => {
          this.num = res.data;
          if (this.num !== 10) {
            this.$notify({
              title: '提示',
              message: '尊敬的家长，目前不在报名时间段内，请留意招生公告',
              duration: 0
            });
          }
        }).finally(() => {

        });
      },
      showSignUp(val) {
        this.project = val;
        this.$refs.signUpDialog.showDialog(this.site, this.project)
      },
      showQrCode(val) {
        this.$refs.qrCodeDialog.showDialog(val);
      },
    },
  }
</script>
<style scoped>
.el-header {
  height: 120px !important;
  background-size: contain;
  font-size: 40px;
  line-height: 120px;
  color: #ffffff; /* 设置文字颜色为白色以便于阅读 */
  display: flex;
  padding: 0px;
}
.header-logo{
  background-color: #081f69;
  height: 120px;
  width: 680px;
  img{
    width: 100%;
    height: 100%;
  }
}
.header-right{
  width: 100%;
  background: linear-gradient(to right, #081f69, #b56af1);
}
.home-main {
  //background-color: #df7f7f;
  width: 1180px;
  margin: 0 auto;
}
.home-main-card {
  width: 1180px;
  margin: 0 auto;

}
.image-card {
  width: 100%; /* 设置 div 的宽度 */
  height: 100%; /* 设置 div 的高度 */
  overflow: hidden; /* 确保图片超出部分被隐藏 */
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持图片比例并裁剪 */
  /* 或者使用 object-fit: contain; 保持图片比例并缩放 */
}
.home-card {
  //box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  //border-radius: 10px;
  margin-top: 100px;
  background-color: #ffffff;
  .home-card-content{
    padding: 20px;
    .home-card-col{
      margin-bottom: 20px;
      .image {
        width: 100%;
        display: block;
        height: auto;
      }
      .name{
        font-size: 25px;
        color: #656363;
        font-weight: bold;
      }
      .bottom {
        margin-top: 13px;
        line-height: 20px;
      }
      .bottom2 {
        margin-top: 13px;
        line-height: 20px;
        width: 70%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block;
      }
      .address-class{
        color: #979494;
        font-size: 15px;
      }
    }
    .button{
      float: right;
      margin-left: 10px;
    }
  }
  margin-bottom: 20px;
}

.title {
  text-align: center; /* 使内容居中 */
}

.subtitle {
  font-weight: bold;
  color: red;
  display: block; /* 使标题独占一行 */
  font-size: 30px;
}
p{
  text-indent: 2em;
  color: #656363;
  font-size: medium;
  line-height: 2em;
}
h2{
  text-indent: 2em;
  font-size: large;
  padding: 10px 0;
}
.content-danger{
  color: red;
}

.el-footer{
  background-color: #081f69;
  color: #ffffff;
  font-size: 15px;
  text-align: center;
  .footer-div{
    padding-top: 20px;
  }
}

</style>
